/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

export const withLegacyStyles = (Component: any) => (props: any) => {
  useEffect(() => {
    if (!window) return;
    // @ts-ignore
    window.document.querySelector('#application')?.classList?.add('legacy');
    return () => {
      // @ts-ignore
      window?.document
        ?.querySelector('#application')
        ?.classList?.remove('legacy');
    };
  }, []);
  return (
    <div style={{ display: 'contents' }} className="legacy_page_styles">
      <Component {...props} />
    </div>
  );
};

export const withLegacyTweakedStyles = (Component: any) => (props: any) => {
  useEffect(() => {
    if (!window) return;
    // @ts-ignore
    window.document
      .querySelector('#application')
      ?.classList?.add('legacy-tweaked');
    return () => {
      // @ts-ignore
      window?.document
        ?.querySelector('#application')
        ?.classList?.remove('legacy-tweaked');
    };
  }, []);
  return (
    <div style={{ display: 'contents' }} className="legacy_tweaked_page_styles">
      <Component {...props} />
    </div>
  );
};
